module.exports = __webpack_public_path__ + "assets/img/mecha-btn-384e8cb4.png";